import ConfigService from "../../../../src/services/config/config.service";

export function GoogleClient(): Promise<gapi.auth2.GoogleAuth> {
  return new Promise<gapi.auth2.GoogleAuth>((resolve, reject) => {
    if (window["auth2"]) {
      gapi.auth2.getAuthInstance().then(resolve);
    }

    window["googleAsyncInit"] = () => {
      gapi.load("auth2", () => {
        window["auth2"] = gapi.auth2.init({
          client_id: ConfigService.getConfig().miscellaneousConfig.googleAppId,
          cookie_policy: "single_host_origin"
        });

        gapi.auth2.getAuthInstance().then(resolve, reject);
      });
    };

    const script = document.createElement("script");
    script.src = "https://apis.google.com/js/platform.js";
    script.async = true;
    script.onload = window["googleAsyncInit"];
    document.body.appendChild(script);
  });
}

export function loginGoogle(): Promise<gapi.auth2.GoogleUser> {
  return new Promise<gapi.auth2.GoogleUser>((resolve, reject) => {
    GoogleClient().then(client => {
      client.signIn().then(resolve);
    });
  });
}

export function isGoogleAuthenticated(): Promise<boolean> {
  return new Promise<boolean>(resolve => {
    GoogleClient().then(client => {
      resolve(client.isSignedIn.get());
    });
  });
}

export function googleCurrentUser(): Promise<gapi.auth2.GoogleUser> {
  return new Promise<gapi.auth2.GoogleUser>((resolve, reject) => {
    GoogleClient().then(client => {
      resolve(client.currentUser.get());
    });
  });
}

export function logoutGoogle() {
  return new Promise<void>((resolve, reject) => {
    GoogleClient().then(client => {
      client.signOut();
      resolve();
    });
  });
}



// WEBPACK FOOTER //
// ./src/components/common/Google/GoogleClient.ts